import { schema, normalize } from 'normalizr';

export const entity = 'integratedPayments';
export const entitySchema = new schema.Entity(entity);
export const listNormalizer = result => normalize(result, [entitySchema]);
